export default "__VITE_ASSET__BaFpMvmk__"